import React from 'react'

const Earrings = () => {
  return (
    <div>Earrings</div>
  )
}

export default Earrings